import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type NavigationRequestStatus = 'pending' | 'success' | 'error' | null;

export interface NavigationState {
  data: string[] | null;
  isLoading: NavigationRequestStatus;
  /**
   * Stable key identifying the principal whose permissions are stored. Covers id,
   * tenant and roles so the cache is invalidated on any principal change, not just
   * a different user id. `null` when unknown.
   */
  principalKey: string | null;
}

export const initialState: NavigationState = {
  data: null,
  isLoading: null,
  principalKey: null,
};

export const navigationPermissionsSlice = createSlice({
  name: 'navigationPermissions',
  initialState,
  reducers: {
    setData: (
      state,
      action: PayloadAction<{ data: NavigationState['data']; principalKey?: string | null }>,
    ) => {
      state.data = action.payload.data;
      state.isLoading = 'success';
      state.principalKey = action.payload.principalKey ?? null;
    },
    setLoading: (state, action: PayloadAction<NavigationRequestStatus>) => {
      state.isLoading = action.payload;
    },
  },
});

export const navigationPermissionsActions = {
  ...navigationPermissionsSlice.actions,
};

export default navigationPermissionsSlice.reducer;
